<template>
  <div>
    <!-- 居中 -->
    <van-row type="flex" justify="center">
      <van-col span="16">
        <div id="step">
          <van-steps :active="active" active-icon="success" active-color="#38f" inactive-icon="arrow">
            <van-step v-for="step in steps" :key="step">{{step}}</van-step>
          </van-steps>
        </div>
      </van-col>
    </van-row>

    <!-- 居中 -->
    <van-row type="flex" justify="center">
      <van-col span="18">
        <!--第一步 创建应用-->
        <transition name="van-slide-right">
        <div v-show="active == 0">
          <div class="service-tip">
            <p>1. 请管理员登录企业微信后台 <br>&nbsp;&nbsp;&nbsp;  <a href="https://work.weixin.qq.com/wework_admin/loginpage_wx" target="_blank">https://work.weixin.qq.com/wework_admin/loginpage_wx</a></p>
            <p>2. 选择 <span class="service-menu">应用管理</span>，点击<span class="service-menu">创建应用</span></p>
            <p>3. 设置 logo 和 可见范围</p>
          </div>

          <van-grid :border="false" :column-num="2">
            <van-grid-item>
              <van-image src="http://zone.histone.wang/img/create1.png" />
            </van-grid-item>
            <van-grid-item>
              <van-image src="http://zone.histone.wang/img/create2.png" />
            </van-grid-item>
          </van-grid>
        </div>
        </transition>

        <!--第二步 填写企业ID-->
        <transition name="van-slide-right">
        <div v-show="active == 1">
          <div class="service-tip">
            <p>1. 选择 <span class="service-menu">我的企业</span></p>
            <p>2. 在页面最底端找到 <span class="service-menu">企业ID</span></p>
<!--            <p>3. 请复制 <span class="service-menu">企业ID</span>，填入下方输入框中</p>-->
<!--            <van-cell-group><van-field v-model="corpId" label="企业ID" placeholder="请输入企业ID" size="large" :readonly="paramSet" /></van-cell-group>-->
          </div>

          <div class="service-one">
            <van-image src="http://zone.histone.wang/img/corpid.png" />
          </div>
        </div>
        </transition>

        <!--第三步 填写应用ID-->
        <transition name="van-slide-right">
        <div v-show="active == 2">
          <div class="service-tip">
            <p>1. 选择 <span class="service-menu">应用管理</span>，找到步骤一创建的应用</p>
            <p>2. 点击应用图标查看应用详情</p>
            <p>3.  <span class="service-menu">应用ID（AgentId）</span> 和 <span class="service-menu">密钥（Secret）</span></p>
          </div>

          <div class="service-one">
            <van-image src="http://zone.histone.wang/img/secret.png" />
          </div>
        </div>
        </transition>

        <!--第四步 上传文件-->
        <transition name="van-slide-right">
        <div v-show="active == 3">
          <div class="service-tip">
            <p>1. 在应用详情页的最底部，找到并点击 <span class="service-menu">设置可信域名</span></p>
            <p>2. 点击弹窗中的 <span class="service-menu">申请校验域名</span></p>
            <p>3. 点击<span class="service-menu">下载文件</span></p>
            <p>4. 将文件和以上步骤获取到的参数，一并提供给运维人员</p>
<!--            <p>4. 请点击下方按钮，上传刚才下载的TXT文件</p>-->
<!--            <van-uploader  :before-read="beforeRead" :after-read="afterRead" accept="text/plain">-->
<!--              <van-button icon="column" type="primary">上传文件</van-button>-->
<!--            </van-uploader>-->
          </div>

          <van-grid :border="false" :column-num="3">
            <van-grid-item>
              <van-image src="http://zone.histone.wang/img/domain1.png" />
            </van-grid-item>
            <van-grid-item>
              <van-image src="http://zone.histone.wang/img/domain2.png" />
            </van-grid-item>
            <van-grid-item>
              <van-image src="http://zone.histone.wang/img/domain3.png" />
            </van-grid-item>
          </van-grid>
        </div>
        </transition>

        <!--第五步 回填域名-->
        <transition name="van-slide-right">
        <div v-show="active == 4">
          <div class="service-tip">
            <p>1. 待运维人员上传文件</p>
            <p>2. 在域名输入框中输入运维人员反馈回的可信域名</p>
            <p>3. 勾选 <span class="service-menu">已上传域名归属校验文件</span>，点击确定</p>
            <p>4. 成功后，链接变为 <span class="service-menu">已启用</span></p>
          </div>

          <van-grid :border="false" :column-num="2">
            <van-grid-item>
              <van-image src="http://zone.histone.wang/img/domain4.png" />
            </van-grid-item>
            <van-grid-item>
              <van-image src="http://zone.histone.wang/img/domain5.png" />
            </van-grid-item>
          </van-grid>
        </div>
        </transition>

      </van-col>
    </van-row>


    <div class="service-btn">
      <van-button plain type="primary" v-show="active!=0" @click="active --">上一步</van-button>
      <van-button plain type="primary" v-show="active != steps.length-1" @click="active ++">下一步</van-button>
    </div>

  </div>
</template>

<script>
import { Row, Col, Image, Steps, Step, Button, Grid, GridItem, Field, CellGroup, Uploader } from 'vant';

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Image.name]: Image,
    [Steps.name]: Steps,
    [Step.name]: Step,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Uploader.name]: Uploader
  },

  data() {
    return {
      active: 0,
      steps: ["创建应用", "查询企业ID", "查询应用ID及密钥", "验证文件", "回填域名"]
    };
  },
  methods: {
  }
};
</script>

<style lang="less">
.service {
  &-tip {
    padding: 20px 0 20px 200px;
  }
  &-menu {
    font-size: 16px;
    font-weight: bolder;
    color: #7070c1;
  }
  &-one {
    width: 60%;
    padding: 0 20%;
  }

  &-btn {
    position: fixed;
    bottom: 50px;
    width: 100%;
    text-align: center;
    .van-button {
      margin: 0 200px;
    }
  }
}
</style>
